export const getStyles = () => {
	return {
		select: {
			'.MuiSelect-select': {
				paddingRight: '25px !important',
				paddingLeft: '5px',
				fontSize: '14px',
			},

			'.MuiOutlinedInput-notchedOutline': {
				border: 'none',
			},
			'& .MuiSvgIcon-root': { fontSize: '20px', maxWidth: '20px' },
		},
	};
};
